import React from 'react';
import { lightTheme, MODULE_THEMES, Theme } from '../Theme';
import { createBasicColorSet } from '@spotify-internal/encore-web';
import { ButtonPrimaryAsLink } from './EncoreCreatorWebHelpers';
import { fixHref } from '../utils';

export type CTAButtonType = {
  ctaText: string;
  ctaLink: string;
  title?: string;
  themeName?: string;
  trackingCategory?: string;
  backgroundColor?: string;
  textColor?: string;
};

export const CTAButton: React.FC<CTAButtonType> = ({
  ctaText = '',
  ctaLink = '',
  title = '',
  themeName = '',
  trackingCategory = '',
  backgroundColor = '',
  textColor = '',
}) => {
  const theme: Theme = {
    ...lightTheme,
    ...(MODULE_THEMES[themeName] || {}),
  };
  // Color set cannot be created with css variables, so we extract the hex value from the color string
  const ctaTextColor =
    theme.cta.text.match(/#[a-f0-9]+/i)?.at(0) || theme.box.background;
  const buttonColorSet = createBasicColorSet(
    backgroundColor || theme.cta.background,
    textColor || ctaTextColor,
  );
  return (
    <ButtonPrimaryAsLink
      href={fixHref(ctaLink)}
      track={[trackingCategory, `CTA Link - ${title}`]}
      UNSAFE_colorSet={buttonColorSet}
    >
      {ctaText}
    </ButtonPrimaryAsLink>
  );
};
